const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const validStationUnit = value => UUID.test(String(value || "")) && !/^0{8}-0{4}-0{4}-0{4}-0{12}$/.test(value);
export const operatorLoginPath = unidadeId => validStationUnit(unidadeId) ? `/producao/login/${unidadeId}` : "/login";
export const operatorTerminalPath = unidadeId => `/producao/terminal/${unidadeId}`;
export const stationUnitFromPath = pathname => {
  const match = /^\/producao\/(?:login|terminal)\/([^/]+)\/?$/i.exec(String(pathname || ""));
  return match && validStationUnit(match[1]) ? match[1] : null;
};
export const sessionLoginPath = pathname => operatorLoginPath(stationUnitFromPath(pathname));
